module.exports = __webpack_public_path__ + "img/Graph3.2271893f.png";